export const CLINIC_POSITION_STATUSES = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  ARCHIVED: 'archived',
  EXPIRED: 'expired',
};
